import type { HttpGet } from '@/shared/infra/http'
import type { ListChannels } from '@/modules/connect/use-cases'
import { mapConnectError } from './map-connect-error'
import { type ChannelDto, toChannel } from './channel-dto'

type ListChannelsResponseDto = {
  channels?: ChannelDto[]
  archivedChannels?: ChannelDto[]
}

export class EdgeListChannelsRepository {
  constructor(private readonly http: HttpGet) {}

  execute: ListChannels = async (params) => {
    const query = `?orgId=${encodeURIComponent(params.orgId)}&orgType=${params.orgType}`
    try {
      const data = await this.http.get<ListChannelsResponseDto>({
        url: `/connect/channels${query}`,
      })
      return {
        channels: (data?.channels ?? []).map(toChannel),
        archivedChannels: (data?.archivedChannels ?? []).map(toChannel),
      }
    } catch (err) {
      throw mapConnectError(err)
    }
  }
}
